<template>
  <div>
    <b-card-code class="mt-2 principal">
      <validation-observer ref="viajeValidation">
        <b-form @submit.prevent>
          <b-row class="mt-1 mb-1">
            <b-col md="6">
              <b-form-group label="Bus" label-for="mc-bus">
                <vue-simple-suggest
                  ref="suggestComponent"
                  v-model="finderfield.modelo.texto"
                  pattern="\w+"
                  prop="bus"
                  label="Bus"
                  :list="obtener_data"
                  :max-suggestions="10"
                  :min-length="1"
                  :debounce="500"
                  :filter-by-query="false"
                  :prevent-submit="true"
                  :controls="{
                    selectionUp: [38, 33],
                    selectionDown: [40, 34],
                    select: [13, 36],
                    hideList: [27, 35],
                  }"
                  :nullable-select="true"
                  placeholder="Search information..."
                  value-attribute="token"
                  display-attribute="value"
                  @select="onSuggestSelect"
                >
                  <div class="g">
                    <validation-provider
                      #default="{ errors }"
                      name="Bus"
                      rules="required"
                    >
                      <b-input-group>
                        <b-form-input
                          v-model="finderfield.modelo.texto"
                          placeholder="Bus"
                        />
                        <b-input-group-append is-text>
                          <feather-icon icon="SearchIcon" />
                        </b-input-group-append>
                      </b-input-group>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                    <div
                      v-if="finderfield.cargando && !finderfield.data"
                      style="
                        min-height: 857px;
                        height: fit-content;
                        width: 100%;
                        position: absolute;
                      "
                    >
                      <img
                        class="loading-gif"
                        src="@/assets/images/bus/loading.gif"
                        alt="loading"
                        style="width: 45px"
                      />
                    </div>
                  </div>
                  <template
                    slot="misc-item-above"
                    slot-scope="{ suggestions, query }"
                  >
                    <div class="misc-item">
                      <span>Buscando '{{ query }}'.</span>
                    </div>
                    <template v-if="suggestions.length > 0">
                      <div class="misc-item">
                        <span
                          >{{ suggestions.length }} resultado(s)
                          encontrado(s)</span
                        >
                      </div>
                      <hr />
                    </template>
                    <div v-else-if="!finderfield.loading" class="misc-item">
                      <span>No hay resultados</span>
                    </div>
                  </template>

                  <div
                    slot="suggestion-item"
                    slot-scope="scope"
                    :title="scope.suggestion.description"
                  >
                    <div class="text">
                      <span v-html="boldenSuggestion(scope)" />
                    </div>
                  </div>

                  <div
                    v-if="finderfield.loading"
                    slot="misc-item-below"
                    slot-scope="{ suggestions }"
                    class="misc-item"
                  >
                    <span>Cargando...</span>
                  </div>
                </vue-simple-suggest>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group label="Chofer" label-for="mc-chofer">
                <vue-simple-suggest
                  ref="suggestComponent"
                  v-model="finderfieldchofer.modelo.texto"
                  pattern="\w+"
                  prop="chofer"
                  label="Chofer"
                  :list="obtener_data_chofer"
                  :max-suggestions="10"
                  :min-length="2"
                  :debounce="500"
                  :filter-by-query="false"
                  :prevent-submit="true"
                  :controls="{
                    selectionUp: [38, 33],
                    selectionDown: [40, 34],
                    select: [13, 36],
                    hideList: [27, 35],
                  }"
                  :nullable-select="true"
                  placeholder="Search information..."
                  value-attribute="token"
                  display-attribute="value"
                  @select="onSuggestSelectChofer"
                >
                  <div class="g">
                    <validation-provider
                      #default="{ errors }"
                      name="Chofer"
                      rules="required"
                    >
                      <b-input-group>
                        <b-form-input
                          v-model="finderfieldchofer.modelo.texto"
                          placeholder="Chofer"
                        />
                        <b-input-group-append is-text>
                          <feather-icon icon="SearchIcon" />
                        </b-input-group-append>
                      </b-input-group>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                    <div
                      v-if="
                        finderfieldchofer.cargando && !finderfieldchofer.data
                      "
                      style="
                        min-height: 857px;
                        height: fit-content;
                        width: 100%;
                        position: absolute;
                      "
                    >
                      <img
                        class="loading-gif"
                        src="@/assets/images/bus/loading.gif"
                        alt="loading"
                        style="width: 45px"
                      />
                    </div>
                  </div>
                  <template
                    slot="misc-item-above"
                    slot-scope="{ suggestions, query }"
                  >
                    <div class="misc-item">
                      <span>Buscando '{{ query }}'.</span>
                    </div>
                    <template v-if="suggestions.length > 0">
                      <div class="misc-item">
                        <span
                          >{{ suggestions.length }} resultado(s)
                          encontrado(s)</span
                        >
                      </div>
                      <hr />
                    </template>
                    <div
                      v-else-if="!finderfieldchofer.loading"
                      class="misc-item"
                    >
                      <span>No hay resultados</span>
                    </div>
                  </template>

                  <div
                    slot="suggestion-item"
                    slot-scope="scope"
                    :title="scope.suggestion.description"
                  >
                    <div class="text">
                      <span v-html="boldenSuggestion(scope)" />
                    </div>
                  </div>

                  <div
                    v-if="finderfieldchofer.loading"
                    slot="misc-item-below"
                    slot-scope="{ suggestions }"
                    class="misc-item"
                  >
                    <span>Cargando...</span>
                  </div>
                </vue-simple-suggest>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <validation-provider
                #default="{ errors }"
                name="Trayecto"
                rules="required"
              >
                <b-form-group
                  label="Trayecto"
                  label-for="trayecto"
                  :state="errors.length > 0 ? false : null"
                >
                  <v-select
                    id="trayecto"
                    v-model="selectedTrayecto"
                    :options="trayectos"
                    label="text"
                    :state="errors.length > 0 ? false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="3">
              <b-form-group>
                <label>Múltiple viajes: </label>
                <b-form-checkbox
                  id="checkbox-3"
                  v-model="mutiple_trip"
                  name="checkbox-3"
                />
              </b-form-group>
            </b-col>
            <b-col md="3" :style="multipleTripStyles">
              <b-form-group>
                <label>Cantidad de viajes: </label>
                <b-form-input
                  id="cantidad_viaje"
                  v-model="cantidad_viaje"
                  type="text"
                  maxlength="2"
                  trim
                />
              </b-form-group>
            </b-col>
            <!-- submit and reset -->
            <b-col md="12">
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                type="submit"
                variant="primary"
                class="mr-1"
                size="sm"
                @click="validationForm"
              >
                <feather-icon
                  icon="SaveIcon"
                  size="16"
                  class="align-text-top"
                />
                Guardar
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-card-code>
  </div>
</template>

<script>
import vSelect from "vue-select";
import VueSimpleSuggest from "vue-simple-suggest";
import "vue-simple-suggest/dist/styles.css";
import { ValidationProvider, ValidationObserver, localize } from "vee-validate";
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BForm,
  BButton,
  BInputGroupAppend,
  BInputGroup,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import BCardCode from "@core/components/b-card-code";
import { required, email, integer } from "@validations";
import { togglePasswordVisibility } from "@core/mixins/ui/forms";
import axios from "@axios";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import es from "vee-validate/dist/locale/es.json";
import actions from "@/assets/utils/utils";
import $ from "jquery";
import Vue from "vue";

localize({
  es,
});

localize("es");

export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BForm,
    BButton,
    BInputGroupAppend,
    BInputGroup,
    BCardCode,
    ValidationProvider,
    ValidationObserver,
    ToastificationContent,
    VueSimpleSuggest,
    vSelect,
  },
  directives: {
    Ripple,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      login_user: "",

      username: "",
      nombres: "",
      apellidos: "",
      identificacion: "",
      user_email: "",
      password: "",
      token: "",
      activo: true,
      required,
      email,
      integer,
      chosen: "",
      mutiple_trip: false,
      cantidad_viaje: 1,

      finderfield: {
        chosen: "",
        selected: null,
        modelo: { texto: "" },
        busqueda: { texto: "" },
        mode: "input",
        loading: false,
        cargando: false,
        data: null,
        dataCompleta: "",
      },

      finderfieldchofer: {
        chosen: "",
        selected: null,
        modelo: { texto: "" },
        busqueda: { texto: "" },
        mode: "input",
        loading: false,
        cargando: false,
        data: null,
        dataCompleta: "",
      },

      token_bus: "",
      token_chofer: "",

      selectedTrayecto: "",
      trayectos: [],
    };
  },
  computed: {
    multipleTripStyles() {
      return this.mutiple_trip === true ? "display: block;" : "display: none;";
    },
    passwordToggleIcon() {
      return this.passwordFieldType === "password" ? "EyeIcon" : "EyeOffIcon";
    },
  },
  mounted() {
    actions.setearTitulo("");
    this.cargarSelectTrayectos();
  },
  created() {
    this.comprobarPermisos();
    $("#btn-excel").remove();
    $("#btn-pdf").remove();
    $("#btn-print").remove();
    $("#eliminar-viajes").remove();
    $("#btn-abrir-caja").remove();
    this.setToken();
  },
  methods: {
    comprobarPermisos() {
      if (
        localStorage.getItem("permisos").indexOf("viaje_viaje_registrar") === -1
      ) {
        this.$router.push({ name: "not-permitted" });
      }
    },
    cargarSelectTrayectos() {
      axios
        .post("api", {
          query: `{
                    getTrayectos{
                        lista{
                            text,
                            value,
                        },
                        status,
                        message
                    }
                }`,
        })
        .then((response) => {
          if (response.status === 200) {
            if (response.data.data.getTrayectos.status === "success") {
              this.trayectos = response.data.data.getTrayectos.lista;
            }
          }
        });
    },
    boldenSuggestion(scope) {
      if (!scope) return scope;
      const { suggestion, query } = scope;
      const result = this.$refs.suggestComponent.displayProperty(suggestion);
      if (!query) return result;
      const texts = query.split(/[\s-_/\\|.]/gm).filter((t) => !!t) || [""];
      return result.replace(
        new RegExp(`(.*?)(${texts.join("|")})(.*?)`, "gi"),
        "$1<b>$2</b>$3"
      );
    },
    onSuggestSelect(suggest) {
      this.finderfield.selected = suggest;
      this.token_bus = this.finderfield.selected.token;
    },
    onSuggestSelectChofer(suggest) {
      this.finderfieldchofer.selected = suggest;
      this.token_chofer = this.finderfieldchofer.selected.token;
    },
    async obtener_data(inputValue) {
      this.finderfield.cargando = true;
      let results;
      await axios
        .post("api", {
          query: `query autocompletar($texto: String!){
                    autocompletar(texto:$texto){
                        lista{
                            token,
                            label,
                            value
                        },
                        status,
                        message
                    }
                }`,
          variables: {
            texto: inputValue,
          },
        })
        .then((response) => {
          if (response.status === 200) {
            if (response.data.data.autocompletar.status === "success") {
              // const datos = response.data.data.autocompletar.lista
              results = response.data.data.autocompletar.lista;
              this.finderfield.data = results;
              this.finderfield.cargando = false;
            }
          }
        });
      const promise = new Promise((resolve, reject) => {
        resolve(results);
      });

      return promise;
    },
    async obtener_data_chofer(inputValue) {
      this.finderfieldchofer.cargando = true;
      let results;
      await axios
        .post("api", {
          query: `query autocompletarUsuario($texto: String!){
                    autocompletarUsuario(texto:$texto){
                        lista{
                            token,
                            label,
                            value
                        },
                        status,
                        message
                    }
                }`,
          variables: {
            texto: inputValue,
          },
        })
        .then((response) => {
          if (response.status === 200) {
            if (response.data.data.autocompletarUsuario.status === "success") {
              // const datos = response.data.data.autocompletar.lista
              results = response.data.data.autocompletarUsuario.lista;
              this.finderfieldchofer.data = results;
              this.finderfieldchofer.cargando = false;
            }
          }
        });
      const promise = new Promise((resolve, reject) => {
        resolve(results);
      });

      return promise;
    },
    validationForm() {
      this.$refs.viajeValidation.validate().then((success) => {
        if (success) {
          this.saveTrayecto();
        }
      });
    },
    saveTrayecto() {
      axios
        .post("api", {
          query: `mutation createViaje($tokenBus: String!, $tokenUsuario: String!, $tokenTrayecto: String!, $checkMasivo: Boolean!, $cantidadRepetir: String!){
                    createViaje(tokenBus:$tokenBus, tokenUsuario:$tokenUsuario, tokenTrayecto: $tokenTrayecto, checkMasivo: $checkMasivo, cantidadRepetir: $cantidadRepetir)
                    {
                        status,
                        message,
                    }
                }`,
          variables: {
            tokenUsuario: this.token_chofer,
            tokenBus: this.token_bus,
            tokenTrayecto: this.selectedTrayecto.value,
            checkMasivo: this.mutiple_trip,
            cantidadRepetir: this.cantidad_viaje,
          },
        })
        .then((response) => {
          if (response.status === 200) {
            if (response.data.data.createViaje.status === "success") {
              this.showToast();
              this.$router.push({ name: "viaje" });
            } else {
              this.$swal({
                title: "Error",
                text: response.data.data.createViaje.message,
                icon: "error",
                confirmButtonColor: "#089599",
              });
            }
          }
        });
    },
    showToast() {
      this.$toast.success(
        {
          component: ToastificationContent,
          props: {
            title: "Viaje",
            icon: "SaveIcon",
            text: "Se ha registrado con éxito un nuevo viaje",
          },
        },
        {
          position: "bottom-right",
        }
      );
    },
    setToken() {
      const usuarioCookie = this.$cookie.get("usuario");
      if (usuarioCookie != null) {
        const user = JSON.parse(usuarioCookie);
        this.login_user = user.username;
        axios.defaults.headers.common.Authorization = `JWT ${user.token}`; // for all requests
      }
    },
  },
};
</script>
<style>
.principal .card-header {
  display: none !important;
}
.principal .card-body {
  padding-bottom: 0 !important;
}
.vue-simple-suggest.designed .input-wrapper input {
  width: auto !important;
}
</style>
